import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Consumer, ConsumerService } from '@app/resources/services';
import { mapToConsumer, mapToConsumers } from '@app/areas/non-members/utils';

@Injectable()
export class NonMembersApiService {
  private readonly consumerService = inject(ConsumerService);

  getNonMember(consumerId: number): Observable<Consumer> {
    return this.consumerService.findNonMember(consumerId).pipe(
      map(mapToConsumer),
      catchError((err) => {
        console.error(err);
        return of(err);
      })
    );
  }

  getNonMembers(): Observable<Consumer[]> {
    return this.consumerService.findNonMembers().pipe(map(mapToConsumers));
  }
}
